// Project Imports
import fetchNeedMasterData from 'utils/fetchNeedMasterData'
import NeedTypeEnum from "constants/NeedTypeEnum";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import AuthStore from 'modules/login/store/AuthStore';
import { EMPLOYER_EMPLOYEE_SCHEME_B, INDIVIDUAL, MWP_ACT } from 'constants/ CustomerType';
import { prefillProductsList } from './utils';
import StorageKeys from 'constants/StorageKeys';

const initialDefaults = async (formController, journeyData, journeyId,) => {
    if (journeyId !== undefined) {
        formController.$("journey_id").value = journeyId.toString()
    }

    let masterData = await fetchNeedMasterData()

    if (masterData.length <= 0) return

    let growMyMoney = masterData.find((item) => item.unique_name === NeedTypeEnum.GROW_MY_MONEY)

    let selectedFamilyMember = journeyData.family_details_list.filter((item) => item.id === OptimizationStore.selectedFamilyMemberId)[0]
    let selfData = ( AuthStore.journeyTypeName === INDIVIDUAL || AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B ||  AuthStore.journeyTypeName === MWP_ACT) ?  journeyData.family_details_list[0] :  journeyData.family_details_list[1]

    let targetAmountOfSelectedFamilyMember = selectedFamilyMember?.family_product_details_list?.find((item) => item.need_unique_name === NeedTypeEnum.GROW_MY_MONEY)
    let targetAmountOfSelf = selfData?.family_product_details_list.find((item) => item.need_unique_name === NeedTypeEnum.GROW_MY_MONEY)
    let selectedTargetAmount =  targetAmountOfSelectedFamilyMember && targetAmountOfSelectedFamilyMember?.target_amount || targetAmountOfSelf && targetAmountOfSelf.target_amount
    let selectedPayoutMode = targetAmountOfSelectedFamilyMember && targetAmountOfSelectedFamilyMember?.payout_mode || targetAmountOfSelf && targetAmountOfSelf.payout_mode
    
    let allProductListData = await prefillProductsList()
    let isUlipUser = localStorage.getItem(StorageKeys.ULIP_TRAINING) === "1"
    let filterdata = []

    if (!isUlipUser) {
        filterdata = allProductListData[NeedTypeEnum.GROW_MY_MONEY] .filter((item) => item.risk != "high");
    } else {
        filterdata = allProductListData[NeedTypeEnum.GROW_MY_MONEY] 
    }

    formController.$("products_list").set("extra", {
      ...formController.$("products_list").extra,
      preDefinedOptList: filterdata ? filterdata: []
    })


    if (selectedTargetAmount) {
        let targetAmount = growMyMoney.target_amount.filter((item) => item.id === selectedTargetAmount)[0]
        formController.$("target_amount_dropdown").set("value", targetAmount)
    } else {
        
        formController.$("target_amount_dropdown").set("value", growMyMoney.target_amount[1])
        let targetAmountList = growMyMoney.target_amount.filter((item) => item.mode.toUpperCase() === growMyMoney.mode_master[0].mode)
        formController.$("target_amount_dropdown").set("extra", {
            ...formController.$("target_amount_dropdown").extra,
            optionList: targetAmountList
        })

    }

    if (selectedPayoutMode) {
        formController.$("target_amount_type").set("extra", {
            ...formController.$("target_amount_type").extra,
            optionList: growMyMoney.mode_master
        })
        let payoutMode = growMyMoney.mode_master.filter((item) => item.mode.toLowerCase() === selectedPayoutMode)[0]
        formController.$("target_amount_type").set("value", payoutMode)

        let targetAmountList = growMyMoney.target_amount.filter((item) => item.mode.toLowerCase() === selectedPayoutMode.toLowerCase())
        formController.$("target_amount_dropdown").set("extra", {
            ...formController.$("target_amount_dropdown").extra,
            optionList: targetAmountList
        })

        let productList = formController.$("products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item.payout_type.toLowerCase()  === selectedPayoutMode)

        formController.$("products_list").set("extra", {
          ...formController.$("products_list").extra,
          optionList: filterProductList ? filterProductList : []
        })
        // formController.$("products_list").set("value", filterProductList[0])
    } else {
        formController.$("target_amount_type").set("extra", {
            ...formController.$("target_amount_type").extra,
            optionList: growMyMoney.mode_master
        })
        formController.$("target_amount_type").set("value", growMyMoney.mode_master[0])

        let productList = formController.$("products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item.payout_type.toLowerCase()  === growMyMoney?.mode_master[0]?.mode.toLowerCase())

        formController.$("products_list").set("extra", {
          ...formController.$("products_list").extra,
          optionList: filterProductList ? filterProductList : []
        })
        // formController.$("products_list").set("value", filterProductList[0])
       
    }
}

export default initialDefaults